// Imports
import { useCallback, useEffect, useState } from 'react';
import LoadingRow from '../../../../../../shareables/foundation/front-end/components/tables/loading-row';
import { useAppDispatch } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import apiActions from '../../../../../../shareables/integrations/api/redux/actions';
import { GetMyPhotosResponse } from '../../../../../../shareables/types/api/main/website/page/type/206/my-photos/get';
import Table from '../shared-components/table';
import PhotoGalleryRow from './row';


// Define the accepted props
interface Props {
	onChange: () => void;
	pageID: number;
	storybookMyPhotos?: GetMyPhotosResponse;
}


// Function component
const PhotoGalleryTable: React.FC<Props> = ({ onChange, pageID, storybookMyPhotos }) => {
	// Use state
	const [photos, setPhotos] = useState<GetMyPhotosResponse | null>(storybookMyPhotos ?? null);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Function that loads photos
	const memoizedLoadMyPhotos = useCallback(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetMyPhotosResponse>({
				action: 'GET',
				uri: `/website/${window.location.hostname}/page/id_${pageID}/type/206/my-photos`,
				completion: (json) => {
					setPhotos(json.response);
				},
			})
		);
	}, [dispatch, pageID]);
	
	
	// Load photos on mount
	useEffect(() => {
		memoizedLoadMyPhotos();
	}, [memoizedLoadMyPhotos]);
	
	
	// Handle change
	const handleChange = useCallback(() => {
		// Reload photo gallery
		onChange();
		
		
		// Reload member photos
		memoizedLoadMyPhotos();
	}, [onChange, memoizedLoadMyPhotos]);
	
	
	// Return JSX
	return (
		<Table>
			<thead>
				<tr>
					<th>Photo</th>
					<th>Caption</th>
					<th style={{ textAlign: 'center' }}>Delete</th>
				</tr>
			</thead>
			
			<tbody>
				{photos?.map((photo, i) => (
					<PhotoGalleryRow key={photo.id} photo={photo} pageID={pageID} onChange={handleChange} index={i} />
				))}
				
				{photos?.length === 0 && (
					<tr>
						<td colSpan={999} style={{ textAlign: 'center' }}>
							<em>You haven’t uploaded any photos yet…</em>
						</td>
					</tr>
				)}
				
				{!photos && <LoadingRow />}
			</tbody>
		</Table>
	);
};

export default PhotoGalleryTable;
